import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

import StripeCardElement from './StripeCardElement';
import StripePaymentElement from '@/common/stripe/StripePaymentElement';
import RegularForm from './regular-form';
import GroupTabForm from './group-tab-form';
import { GroupTabLogger } from '@/legacy/api/GroupTabLogger';

class DirectForm extends React.Component {
    static propTypes = {
        online_only: PropTypes.bool.isRequired,
        location: PropTypes.object,
        payment_processor: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
    };

    page_name = 'order-confirmation-payment-direct-form';

    componentDidMount() {
        if (
            this.props.payment_processor.name === 'GroupTab' &&
            Mobi2Go.Customer.getGroupTabPaymentName() === ''
        ) {
            const groupTabLogger = new GroupTabLogger(this.page_name);
            groupTabLogger.error('Group Tab Payment Name is empty');
        }
    }

    render() {
        if (this.props.location === null) {
            return null;
        }

        const is_stripe_elements_form =
            this.props.payment_processor.name === 'Stripe' ||
            this.props.payment_processor.name === 'StripeCustomConnect' ||
            this.props.payment_processor.name === 'Mobi2GoPayments';

        const is_group_tab = this.props.payment_processor.name === 'GroupTab';

        const { t } = this.props;
        return (
            <div className="m2g-order-confirmation-online-payment-direct-form">
                <form className="m2g-order-confirmation-payment-cc-form">
                    {this.props.online_only && (
                        <div className="m2g-order-confirmation-payment-cc-form-title m2g-title-text">
                            {t('direct_form_online_only_label')}
                        </div>
                    )}
                    {is_stripe_elements_form ? (
                        this.props.payment_processor._properties
                            ?.use_payment_element ? (
                            <StripePaymentElement
                                paymentProcessor={this.props.payment_processor}
                                layout={this.props.payment_processor._properties?.payment_element_layout}
                                isApplePayEnabled={this.props.payment_processor._properties?.is_apple_pay_enabled ?? false}
                            />
                        ) : (
                            <StripeCardElement
                                payment_processor={this.props.payment_processor}
                            />
                        )
                    ) : is_group_tab ? (
                        <GroupTabForm
                            payment_processor={this.props.payment_processor}
                        />
                    ) : (
                        <RegularForm
                            payment_processor={this.props.payment_processor}
                        />
                    )}
                    <div className="m2g-order-confirmation-payment-trading-name">
                        {this.props.location.trading_name}
                        <br />
                        {`${this.props.location.sales_tax.number_prefix} ${this.props.location.tax_number}`}
                    </div>
                </form>
            </div>
        );
    }
}

export default forwardRefWithTranslation('order.confirmation')(DirectForm);
